import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Bg from "../assets/whychoose-bg.png"

gsap.registerPlugin(ScrollTrigger);

const leftPoints = [
  {
    title: "Expert Surgeons",
    desc: "Our team of highly qualified and experienced hair transplant surgeons has performed thousands of successful procedures with precision and care.",
  },
  {
    title: "Sapphire FUE & DHI Techniques",
    desc: "We use the latest Sapphire FUE & DHI methods for natural-looking, permanent results with minimal downtime.",
  },
  {
    title: "Affordable Pricing",
    desc: "World-class hair restoration at transparent, competitive prices. No hidden costs — just customised care that fits within your budget.",
  },
];

const rightPoints = [
  {
    title: "Natural Hair Growth Results",
    desc: "Our procedures are designed to mimic your natural hairline and growth direction, ensuring results that look and feel completely natural.",
  },
  {
    title: "Hygienic & Safe Environment",
    desc: "All procedures are performed in fully sterilised, international standard facilities ensuring the highest levels of patient safety and hygiene.",
  },
  {
    title: "Post-Surgery Support",
    desc: "We provide dedicated aftercare and follow-up consultations to monitor your recovery and ensure the best possible growth outcome.",
  },

];

export default function WhyChooseUs() {
  const sectionRef  = useRef(null);
  const eyebrowRef  = useRef(null);
  const headingRef  = useRef(null);
  const subRef      = useRef(null);
  const imageRef    = useRef(null);
  const leftRefs    = useRef([]);
  const rightRefs   = useRef([]);
  const lineRef     = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {

      // Eyebrow
      gsap.fromTo(eyebrowRef.current,
        { opacity: 0, y: 16 },
        { opacity: 1, y: 0, duration: 0.6, ease: "power2.out",
          scrollTrigger: { trigger: eyebrowRef.current, start: "top 88%", toggleActions: "play none none reverse" } }
      );

      // Heading
      gsap.fromTo(headingRef.current,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.7, ease: "power2.out",
          scrollTrigger: { trigger: headingRef.current, start: "top 88%", toggleActions: "play none none reverse" } }
      );

      // Sub
      gsap.fromTo(subRef.current,
        { opacity: 0, y: 16 },
        { opacity: 1, y: 0, duration: 0.6, ease: "power2.out",
          scrollTrigger: { trigger: subRef.current, start: "top 88%", toggleActions: "play none none reverse" } }
      );

      // Center image
      gsap.fromTo(imageRef.current,
        { opacity: 0, scale: 0.92, y: 30 },
        { opacity: 1, scale: 1, y: 0, duration: 1, ease: "power2.out",
          scrollTrigger: { trigger: imageRef.current, start: "top 82%", toggleActions: "play none none reverse" } }
      );

      // Vertical line grows down
      gsap.fromTo(lineRef.current,
        { scaleY: 0, transformOrigin: "top center" },
        { scaleY: 1, duration: 1.2, ease: "power2.out",
          scrollTrigger: { trigger: lineRef.current, start: "top 85%", toggleActions: "play none none reverse" } }
      );

      // Left points — slide in from left, one by one
      leftRefs.current.forEach((el, i) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, x: -40 },
          {
            opacity: 1, x: 0, duration: 0.65, ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 87%",
              toggleActions: "play none none reverse",
            },
            delay: 0.05 * i,
          }
        );
      });

      // Right points — slide in from right, one by one
      rightRefs.current.forEach((el, i) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, x: 40 },
          {
            opacity: 1, x: 0, duration: 0.65, ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 87%",
              toggleActions: "play none none reverse",
            },
            delay: 0.05 * i,
          }
        );
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700;900&family=Raleway:wght@300;400;500&display=swap"
        rel="stylesheet"
      />
      <style>{`
        .wcu-section {
          width: 100%;
          background: #080600;
          padding: 100px 0 110px;
          overflow: hidden;
          position: relative;
        }

        /* subtle radial glow behind center */
        .wcu-section::before {
          content: '';
          position: absolute;
          top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          width: 60%;
          height: 70%;
          background: radial-gradient(ellipse at center, rgba(201,168,76,0.06) 0%, transparent 70%);
          pointer-events: none;
        }

        .wcu-inner {
          max-width: 1240px;
          margin: 0 auto;
          padding: 0 48px;
        }

        /* ── HEADER ── */
        .wcu-header {
          text-align: center;
          margin-bottom: 72px;
          margin-top:-40px;
        }
           .ab__timeline-eyebrow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;
}

.ab__timeline-eyebrow::before,
.ab__timeline-eyebrow::after {
  content: "";
  width: 24px; 
  height: 1px;
  background: #c9a84c;
  display: block;
}
        .wcu-eyebrow {
          font-family: 'Cinzel', serif;
          font-size: 10px;
          letter-spacing: 0.3em;
          text-transform: uppercase;
          color: #c9a84c;
          margin-bottom: 14px;
          opacity: 0;
        }
        .wcu-heading {
          font-family: 'Cinzel', serif;
          font-weight: 900;
          font-size: clamp(1.6rem, 3vw, 2.6rem);
          line-height: 1.12;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: #ffffff;
          margin-bottom: 18px;
          opacity: 0;
        }
        .wcu-sub {
          font-family: 'Raleway', sans-serif;
          font-weight: 300;
          font-size: 15px;
          line-height: 1.75;
          color: rgba(255,255,255,0.45);
          max-width: 560px;
          margin: 0 auto;
          opacity: 0;
        }

        /* ── BODY GRID ── */
        .wcu-body {
          
          display: grid;
          grid-template-columns: 1fr auto 1fr;
          gap: 0 40px;
          align-items: start;
        }

        /* ── POINT COLUMNS ── */
        .wcu-col {
          display: flex;
          flex-direction: column;
          gap: 0;
        }
        .wcu-col-left { text-align: right; }
        .wcu-col-right { text-align: left; }

        .wcu-point {
          padding: 28px 0;
          border-bottom: 1px solid rgba(201,168,76,0.09);
          opacity: 0;
        }
        .wcu-point:first-child { padding-top: 0; }
        .wcu-point:last-child { border-bottom: none; }

        .wcu-point-title {
          font-family: 'Cinzel', serif;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #c9a84c;
          margin-bottom: 8px;
        }
        .wcu-point-desc {
          font-family: 'Raleway', sans-serif;
          font-size: 13.5px;
          font-weight: 300;
          line-height: 1.8;
          color: rgba(255,255,255,0.52);
        }

        /* ── CENTER IMAGE + LINE ── */
        .wcu-center {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }
        .wcu-image-wrap {
          width: 260px;
          border-radius: 10px;
          overflow: hidden;
          position: relative;
          flex-shrink: 0;
          opacity: 0;
          box-shadow: 0 0 60px rgba(201,168,76,0.1), 0 20px 60px rgba(0,0,0,0.5);
        }
        .wcu-image-wrap::after {
          content: '';
          position: absolute; inset: 0;
          border: 1px solid rgba(201,168,76,0.22);
          border-radius: 10px;
          pointer-events: none;
        }
        .wcu-image-wrap img {
          width: 100%;
          display: block;
          object-fit: cover;
        }

        /* vertical gold line below image */
        .wcu-vline {
          width: 1px;
          flex: 1;
          min-height: 40px;
          background: linear-gradient(to bottom, rgba(201,168,76,0.5), rgba(201,168,76,0.05));
          margin-top: 0;
        }

        /* dot on center column */
        .wcu-dot {
          width: 8px; height: 8px;
          border-radius: 50%;
          background: #c9a84c;
          box-shadow: 0 0 10px rgba(201,168,76,0.6);
          flex-shrink: 0;
          margin: 6px 0;
        }
          /* LEFT COLUMN */
.wcu-col-left .wcu-point:nth-child(1) { margin-right: 5px; }
.wcu-col-left .wcu-point:nth-child(2) { margin-right: 50px; }
.wcu-col-left .wcu-point:nth-child(3) { margin-right: 150px; }
.wcu-col-left .wcu-point:nth-child(4) { margin-right: 5px; }

/* RIGHT COLUMN */
.wcu-col-right .wcu-point:nth-child(1) { margin-left: 10px; }
.wcu-col-right .wcu-point:nth-child(2) { margin-left: 50px; }
.wcu-col-right .wcu-point:nth-child(3) { margin-left: 150px; }
.wcu-col-right .wcu-point:nth-child(4) { margin-left: 20px; }

@media (max-width: 960px) {
  .wcu-section { padding: 60px 0 70px; }
  .wcu-header { margin-top: 0; margin-bottom: 44px; }
  .wcu-body { grid-template-columns: 1fr; gap: 0; }
  .wcu-center { display: none; }
  .wcu-col { gap: 0; }
  .wcu-col-left,
  .wcu-col-right { text-align: left; }
  .wcu-inner { padding: 0 24px 90px; } /* extra bottom padding clears floating call/WhatsApp buttons */

  /* kill all desktop stagger offsets — they only make sense in the 3-column layout */
  .wcu-col-left .wcu-point:nth-child(1),
  .wcu-col-left .wcu-point:nth-child(2),
  .wcu-col-left .wcu-point:nth-child(3),
  .wcu-col-left .wcu-point:nth-child(4),
  .wcu-col-right .wcu-point:nth-child(1),
  .wcu-col-right .wcu-point:nth-child(2),
  .wcu-col-right .wcu-point:nth-child(3),
  .wcu-col-right .wcu-point:nth-child(4) {
    margin-left: 0;
    margin-right: 0;
  }

  .wcu-point { padding: 22px 0; }
  .wcu-point-title { font-size: 12px; }
  .wcu-point-desc { font-size: 13px; line-height: 1.7; }
}

@media (max-width: 960px) {
  .wcu-section {
    background-image: none !important;
    background-color: #080600 !important;
  }
}

@media (max-width: 420px) {
  .wcu-heading { font-size: clamp(1.3rem, 6vw, 1.7rem); }
  .wcu-sub { font-size: 13.5px; }
  .wcu-inner { padding: 0 18px 90px; }
}
      `}</style>

      <section ref={sectionRef} className="wcu-section" style={{
    backgroundImage: `url(${Bg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="wcu-inner">

          {/* ── HEADER ── */}
          <div className="wcu-header">
            <p ref={eyebrowRef} className="wcu-eyebrow ab__timeline-eyebrow">Hair Restoration Excellence</p>
            <h2 ref={headingRef} className="wcu-heading">
              Why People Choose<br /> Clinique Internationale
            </h2>
            <p ref={subRef} className="wcu-sub">
              Thousands of patients have trusted Clinique Internationale for their hair restoration journey.
              Here's what sets us apart from the rest.
            </p>
          </div>

          {/* ── BODY ── */}
          <div className="wcu-body">

            {/* LEFT POINTS */}
            <div className="wcu-col wcu-col-left">
              {leftPoints.map((pt, i) => (
                <div
                  key={i}
                  className="wcu-point"
                  ref={el => leftRefs.current[i] = el}
                >
                  <p className="wcu-point-title">{pt.title}</p>
                  <p className="wcu-point-desc">{pt.desc}</p>
                </div>
              ))}
            </div>

            {/* CENTER IMAGE + LINE */}
            <div className="wcu-center">
              <div className="wcu-dot" />
              <div ref={imageRef} className="wcu-image-wrap">
            
              </div>
              <div ref={lineRef} className="wcu-vline" />
              <div className="wcu-dot" style={{ marginTop: "0" }} />
            </div>

            {/* RIGHT POINTS */}
            <div className="wcu-col wcu-col-right">
              {rightPoints.map((pt, i) => (
                <div
                  key={i}
                  className="wcu-point"
                  ref={el => rightRefs.current[i] = el}
                >
                  <p className="wcu-point-title">{pt.title}</p>
                  <p className="wcu-point-desc">{pt.desc}</p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

